<div class="carousel-indicator" [ngClass]="'indicator-theme-' + theme">
  <div class="carousel-item" *ngFor="let i of items; trackBy: trackByIndex" [ngClass]="{'carousel-active':  i === current}" (click)=change(i);></div>
</div>
